import React from 'react';
import './NavBar.scss';
import Logo from '../Common/Logo/Logo';
import Arrow from '../Common/Arrow/Arrow';
import { navItems } from '../../navItems';

function NavBar({ positionMobileMenu, navBarRef }) {
  return (
    <nav className="navBar" ref={navBarRef}>
      <div className="navBar__contents navBar__contents-mobile">
        <h2 className="navBar__contents__text navBar__contents__text-mobile">
          THE EVOLUTION OF INCLUSIVE SPACESUIT DESIGN
        </h2>
        <button
          className="navBar__contents__menu"
          aria-controls="menu"
          onClick={positionMobileMenu}
        >
          <div className="navBar__contents__menu__bar navBar__contents__menu__bar-top" />
          <div className="navBar__contents__menu__bar navBar__contents__menu__bar-bttm" />
        </button>
      </div>
      <div className="navBar__contents navBar__contents-desktop">
        <a
          href="https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/"
          target="_blanc"
          className="navBar__contents__logo"
        >
          <Logo location="nav" />
        </a>

        {navItems.map((item, i) => {
          return (
            <a
              key={i}
              className="navBar__contents__text navBar__contents__text__link"
              href={`#${item.href}`}
            >
              {item.copy}
            </a>
          );
        })}
        <a
          className="navBar__contents__text navBar__contents__text__link"
          href="https://www.morganstanley.com/Themes/global-space-economy/?cid=mg-cap-cnncreat-12577"
          target="_blank"
          rel="noreferrer"
        >
          EXPLORE THE NEW SPACE ECONOMY <Arrow location="nav" />
        </a>
      </div>
    </nav>
  );
}

export default NavBar;
